<template>
  <div>
    <HeaderInnerPage
      id="how-works"
      title="Contato"
      :background="bgPage"
    >Escolha um canal para obter suporte
    </HeaderInnerPage>

    <section class="pb-5">
      <b-container>


        <b-row class="mt-5">
           <b-col v-if="0">
              <el-form
                 :model="contact"
                 :rules="contactRules"
                 ref="contact"
                 class=""
                 size="small"
                 v-loading="loading"
              >

                 <!-- Name and CPF | Nome e CPF -->
                 <el-row :gutter="20">

                    <el-col :span="24" :sm="12">
                       <el-form-item label="Nome" prop="firstName">
                          <el-input v-model="contact.name" :readonly="true"
                                    disabled></el-input>
                       </el-form-item>
                    </el-col>

                    <el-col :span="24" :sm="12">
                       <el-form-item label="Sobrenome" prop="lastName">
                          <el-input v-model="user.lastName" :readonly="true"
                                    disabled></el-input>
                       </el-form-item>
                    </el-col>

                 </el-row>
              </el-form>
           </b-col>


          <b-col lg="4" class="mb-5 mb-lg-0">
            <el-card class="box-card help">
              <div  class="text item">
                <div class="icon">
                  <v-icon class="icon" scale="5" name="comments"></v-icon>
                </div>
                <h5>Nosso WhatsApp</h5>
                 <a class="btn btn-sm btn-primary my-2 px-4" target="_blank" href="https://wa.me/5551983599666">Clique Aqui</a>
              </div>
            </el-card>
          </b-col>
          <b-col lg="4" class="mb-5 mb-lg-0">
            <el-card class="box-card help">
              <div  class="text item">
                <div class="icon">
                  <v-icon class="icon" scale="4.2" name="envelope"></v-icon>
                </div>
                <h5>Suporte ao Ciclista</h5>
                <p>contato@pedale.net.br</p>
              </div>
            </el-card>
          </b-col>
          <b-col lg="4">
            <el-card class="box-card help">
              <div  class="text item">
                <div class="icon">
                  <v-icon class="icon" scale="3.8" name="file-alt"></v-icon>
                </div>
                <h5>Nossa Política de Uso</h5>
                <p><router-link class="text-dark" to="/politicas-pedale">Acesse Agora →</router-link></p>
              </div>
            </el-card>
          </b-col>
        </b-row>

      </b-container>
    </section>

    <CallToActionSection
      class="mt-5"
      title="Quer alugar sua bicicleta?"
      desc="É fácil, rápido e seguro alugar sua bicicleta."
      textLink="ANUNCIAR BICICLETA"
      link="/registrar"

    />

  </div>
</template>

<script>
    import bgPage from '@/assets/img/ajuda-pedale.jpg';
    import HeaderInnerPage from "@/components/HeaderInnerPage.vue";
    import CallToActionSection from "@/components/CallToActionSection";
    import {metaTags} from "@/helpers";


    export default {
        name: 'Contact',
        metaInfo: metaTags(`Contato`),
        components: {
            HeaderInnerPage,
            CallToActionSection
        },
        data() {
            return {
                bgPage,
               contact: {
                  name: '',
                  phone: '',
                  email: '',
                  subject: '',
                  message: '',
               },
               contactRules: {
                  name: [
                     {required: true, message: 'Por favor, digite seu Nome', trigger: 'blur'},
                  ],
                  phone: [
                     {required: true, message: 'Por favor, digite seu telefone', trigger: 'blur'},
                  ],
                  email: [
                     {required: true, message: 'Por favor, digite seu E-mail', trigger: 'blur'},
                     {type: 'email', message: 'Digite um e-mail válido!', trigger: ['blur', 'change']}
                  ],
                  subject: [
                     {required: true, message: 'Por favor, digite o assunto', trigger: 'blur'},
                  ],
                  message: [
                     {required: true, message: 'Por favor, digite a mensagem', trigger: 'blur'},
                  ],
               },
               loading: false
            }
        },
    }
</script>

<style lang="scss">

</style>
